import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Icon } from 'shared/components';
import { FormattedMessage } from 'react-intl';
import { MenuItem, Menu, withStyles } from '@material-ui/core';

import theme from './DropdownMenu.scss';
import FilterIconWithHint from './IconWithHint';

const propTypes = {
  anchorEl: PropTypes.any,
  classes: PropTypes.object.isRequired,
  openPopover: PropTypes.func.isRequired,
  closePopover: PropTypes.func.isRequired,
  cancelAppointment: PropTypes.func.isRequired,
  hasCancelPermission: PropTypes.bool.isRequired,
  canCloseCurrentAppointment: PropTypes.bool.isRequired,
  canUpdateAppointment: PropTypes.bool.isRequired,
  editAppointmentDetails: PropTypes.func.isRequired,
  userIsOnCall: PropTypes.bool.isRequired,
};

const defaultProps = {
  anchorEl: undefined,
};

const DropdownMenu = ({
  anchorEl,
  openPopover,
  closePopover,
  cancelAppointment,
  canCloseCurrentAppointment,
  hasCancelPermission,
  canUpdateAppointment,
  editAppointmentDetails,
  classes,
  userIsOnCall,
}) => {
  if (!(canCloseCurrentAppointment && hasCancelPermission) && !canUpdateAppointment) return <div />;

  return (
    <Fragment>
      <FilterIconWithHint openPopover={ openPopover } />

      <Menu
        anchorEl={ anchorEl }
        open={ !!anchorEl }
        onClose={ closePopover }
        getContentAnchorEl={ null }
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PopoverClasses={{
          paper: classes.topRightArrow,
        }}
      >
        <If condition={ canUpdateAppointment && !userIsOnCall }>
          <MenuItem
            onClick={ editAppointmentDetails }
            data-testid="cancel-appt-from-dropdown-button"
          >
            <Icon name="pencil" className={ theme.itemIcon } />
            <span className={ theme.itemText }>
              <FormattedMessage
                id="Patient.Appointment.AppointmentInfo.3DotsMenu.EditAppointment"
                defaultMessage="** Edit Appointment"
              />
            </span>
          </MenuItem>
        </If>
        <If condition={ hasCancelPermission }>
          <MenuItem
            onClick={ () => {
              cancelAppointment();
              closePopover();
            } }
            data-testid="cancel-appt-from-dropdown-button"
          >
            <Icon name="naked-x" />
            <span className={ theme.itemText }>
              <FormattedMessage
                id="Appointments.CancelAppointment.CancelDialog.Title"
                defaultMessage="** Cancel Appointment"
              />
            </span>
          </MenuItem>
        </If>
      </Menu>
    </Fragment>
  );
};

DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;

export default withStyles(({ topRightArrow }) => ({ topRightArrow }))(DropdownMenu);
